module.exports = __webpack_public_path__ + "fonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1x4iaVIGxA.3befb44.woff2";